import React from 'react';
import DsModal from '../DsModal';
import { useAnnouncements } from '../../../contexts/AnnouncementContext';
import { formatDateTime, renderBody } from './announcementUtils';
import '../../../css/common/announcements/Announcements.css';

function AnnouncementPopup() {
  const { popupAnnouncement, acknowledgePopup } = useAnnouncements();

  if (!popupAnnouncement) return null;

  return (
    <DsModal
      open
      onClose={() => acknowledgePopup(popupAnnouncement)}
      title={popupAnnouncement.title}
      size="lg"
      className="announcement-detail-modal"
    >
      <p className="announcement-detail-modal__date">
        {formatDateTime(popupAnnouncement.publishedAt)}
      </p>
      <div className="announcement-card__body">{renderBody(popupAnnouncement.body)}</div>
    </DsModal>
  );
}

export default AnnouncementPopup;
